<template>
  <!--关注的-->
  <div class="follow" v-infinite-scroll="loadMore"  infinite-scroll-disabled="busy" infinite-scroll-distance="10" infinite-scroll-throttle-delay="1000">
  <div class="ay-content-list" v-if="MyFollow.length">
    <div class="ay-link ay-cor"  v-for="(item,ind) in MyFollow">
      <div class="foll" v-if="item.status !=='2'">
    <!--    <div class="ay-close" @click="ayClose(ind)"></div>-->
     <!--   <p class="ay-title-time">{{item.follow_time}}</p>-->
        <p class="ay-title-time">{{item.create_time|datetime}}</p>
        <router-link tag="div" class="ay-inr" :to="{name:'Detail',params: {id:item.id,route:item.playbill}}">
      <!--  <div class="ay-inr">-->
          <div class="ay-pic-box">
            <img class="ay-pic" :src="item.playbill.playbill_small_h5 +'?p=3&o=2&w=350&h=197'" alt="" />
            <i class="ay-pic-t"></i>
          </div>
          <p class="ay-title">{{item.title}}</p>
          <p v-if="item.end_time != ''" class="ay-time">{{item.end_time,item.start_time|orderBys}}</p>
          <p v-else class="ay-time">永久活动</p>
        <!--</div>-->
        </router-link>
        <div class="btn-ay">
          <a href="javascript:void(0);" class="btn-ay-red" :attr-id="item.id">取消关注</a>
        </div>
      </div>
      <div class="ay-atten">
        <img  v-if="item.hostunit" class="ay-atten-pic" :src="item.hostunit.host_avatar" alt=""/>
        <p v-if="item.hostunit">{{item.hostunit.channel_title}} {{item.hostunit.column_name}}</p>
        <router-link class="ay-more" to="/find">更多活动</router-link>
      </div>
    </div>
  </div>
  <div class="foll_div"  v-else>
    <div class="content index-content">
      <div class="id-content-inner">
        <div class="loader">
          <div class="loader-inner ball-pulse" style="display: block">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <!--<img class="loading-currency" style="width: 40px;height:40px;"   src="../../../static/dist/img/Loading.jpg" alt=""/>-->
  </div>
    <!-- load -->
    <div class="content index-content" v-show="!busy" style="padding-top: 5px">
      <div class="id-content-inner">
        <div class="loader">
          <div class="loader-inner ball-pulse" style="display: block">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
    <div class="sing-modal upload-modal large-info-modal modal fade" id="editModal" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-inner">
              <div class="pl-form">
                <h3 class="Prompt-p">你确定要取消关注？  </h3>
                <div class="btn-modal-tw">
                  <a href="javascript:void(0);" class="btn-pl-start" @click="editcComplete()">完成</a>
                  <a href="javascript:void(0);" class="btn-pl-start" data-dismiss="modal">取消</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props: [
        'userId',
        'initUtil'
      ],
      data (){
        return {
          MyFollow: [],
          id : '',
          ind: '',
          busy : false,
          page: 0
        }
      },
      methods: {
          // 操作按钮事件
        // 取消关注
        editcComplete(){
        // 取消关注
          var that = this
          var delFollo = {
            user_id:  that.userId, // 账户id
            item_id : that.id,  // 活动id
            type: 0
          };
         // console.log(delFollo)
          this.$http.get(API.DelActivityFollow, {params: delFollo})
            .then(function (res) {
           // console.log(res);
            if(res.code == 0){
              $('#editModal').modal('hide');
              $('.ay-title-time').eq(that.ind).parents('.ay-cor').remove();
            }
          })
          },
        //加载更多
        loadMore(){
          this.busy = true;
          // 多次加载数据
          setTimeout(() => {
            this.page ++;
          this.ajaxMore(true);
        }, 500)
      },
      ajaxMore(flag){
        var that = this;
        this.$http.get(API.GetActivitieFollowByUserid, {params: {page: that.page,pagesize: 10}})
          .then(function (res) {
            //console.log(res)
            if(res.code == 0){
              if(flag){
                for(var i=0;i<res.data.length;i++){
                  that.MyFollow.push(res.data[i])
                }
                if (res.data.length === 0 || that.MyFollow.length === res.total) {
                  that.busy = true
                } else {
                  that.busy = false
                }
              }
              if(res.total == 0){
                $('.foll_div').html('您还没有关注活动！')
              }
            }
          });

        },
    },
    beforeRouteLeave(to, from, next) {
      // 设置下一个路由的 meta
      to.meta.keepAlive = true;
      next();
    },
    created:function(){
      $('.icon-back').removeClass('pointerEve');
    },
    mounted: function () {
        // 操作DOM
      $('.icon-back').show();
      var that = this;
      this.initUtil.stopBodyScroll(false);
      $('.follow').on('click','.btn-ay-red',function(){
        //console.log(1)
        that.ind = $(this).parents('.foll').index();
        that.id = $(this).attr('attr-id');
       // console.log(that.id,that.ind)
        $('#editModal').modal('show')
      })


        $('.nav').children('.id-nav-recom').eq(1).addClass('nav-on').siblings().removeClass('nav-on')
        $('.nav').find('.id-nav-recom').eq(1).addClass('router-link-exact-active').siblings().removeClass('router-link-exact-active')

      // 微信分享
      let metas = $('head').children('meta');
    }

  }
</script>

<style>
.followDiv{
  line-height: 200px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/myActivity/follow.vue